import { Box, Button, MenuItem, Menu, Card, Checkbox, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, ButtonGroup } from '@mui/material';
import { Search as SearchIcon, Download as ExportIcon,  } from 'react-feather';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React, { useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import CustomButton from 'src/components/common/customButton';

const AhcResults = ({ totalCount, exportFile, onPaginationChange, displayEmployees, allEmployees, activeBookings, activeTable, ...props }) => {
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [exportType, setExportType] = useState('xlsx');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [employees, setEmployees] = useState((displayEmployees.length > 0) && displayEmployees.slice(page * limit, (page + 1) * limit));
  const fileList = [{
    id: 'XLSX',
    title: 'xlsx'
  },{
    id: 'CSV',
    title: 'csv'
  }]

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    if(activeTable == 0 || activeTable == 2 || activeTable == 3 || activeTable == 4) {
      onPaginationChange('limit', event.target.value);
    }
  };

  const handleClose = (item) => {
    setAnchorEl(null);
    if(item){
      setExportType(item.title)
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if(activeTable == 0 || activeTable == 2 || activeTable == 3 || activeTable == 4) {
      onPaginationChange('page', newPage);
    }
  };

  const switchTab = (num) =>{
    setPage(0)
    setLimit(5)
    props.setActiveTable(num)
  }

  return (
    <>
      <Grid container>
        <Grid xs={12} justifyContent="space-between" container item>
          <Grid item container
            sx={{
              borderRadius: 3,
              border: '1px solid #1778f2',
              width: '456px',
              height: '40px'
            }}>
            <CustomButton
              onClick={() => switchTab(0)} fontSize={12} shadow="false" active={activeTable == 0} title="All Employees"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }} />
            <CustomButton
              onClick={() => switchTab(1)} fontSize={12} shadow="false" active={activeTable == 1} title="Employee Utilisation"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }} />
            {/* <CustomButton
              onClick={() => switchTab(2)} fontSize={12} shadow="false" active={activeTable == 2} title="Eligible Employees"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }} /> */}
            <CustomButton
              onClick={() => switchTab(2)} fontSize={12} shadow="false" active={activeTable == 2} title="Active Bookings"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }} />
              {/* <CustomButton
              onClick={() => switchTab(4)} fontSize={12} shadow="false" active={activeTable == 4} title="Master Bookings"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }} /> */}
          </Grid>
          <Grid item container 
            sx={{
              width: '180px',
            }}>
            <ButtonGroup variant="text" disabled={false} sx={{boxShadow: '0 0 4px rgba(0,0,0,0.20)', borderRadius: 15}}>
                <Button sx={{ px: 2 }} onClick={() => exportFile(exportType)} 
                startIcon={<ExportIcon size="18"/>}>
                  Export
                </Button>
                <Button onClick={(e)=> setAnchorEl(e.currentTarget)} endIcon={<ArrowDropDownIcon/>}>
                  {exportType}
                </Button>
              </ButtonGroup>
          </Grid>
        </Grid>
        <Menu
          id="export-menu"
          open={open}
          anchorEl={anchorEl}
          onClose={()=>handleClose()}
          MenuListProps={{
            'aria-labelledby': 'exporttypeMenu',
          }}
        >
          { fileList.map((menu) => 
              <MenuItem key={menu.id} onClick={()=> handleClose(menu)}>{menu.title}</MenuItem>
            ) }
        </Menu>
        <Grid xs item>
          <Card elevation={0} sx={{
            mt: 2
          }}>
            <PerfectScrollbar>
              <Box sx={{ minWidth: activeTable == 4 ? 1800 : 1250 }}>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table stickyHeader aria-label="Employee list" id="employee-list">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            sx={{
                              '& .MuiSvgIcon-root': {
                                fontSize: 18
                              }
                            }}
                            color="primary"
                          />
                        </TableCell>
                        {(activeTable === 0 || activeTable === 1 || activeTable === 2 || activeTable == 3 || activeTable == 4) &&
                          <>
                            <TableCell>
                              Employee ID
                            </TableCell>
                          </>
                        }
                        {(activeTable === 2 || activeTable === 4) &&
                          <>
                            <TableCell>
                              Appointment ID
                            </TableCell>
                          </>
                        }
                        <TableCell>
                          Patient Name
                        </TableCell>
                        {(activeTable === 2 || activeTable === 4) &&
                          <TableCell>
                            Relation
                          </TableCell>
                        }
                        {(activeTable == 0 || activeTable == 1 || activeTable == 4) && 
                          <TableCell>
                            Gender
                          </TableCell>
                        }
                        {(activeTable === 0 || activeTable === 1) &&
                          <TableCell>
                            Date of Birth
                          </TableCell>
                        }
                        {(activeTable === 1 || activeTable === 4) &&
                          <TableCell>
                            Age
                          </TableCell>
                        }
                        {(activeTable !== 0) &&
                          <TableCell>
                            Phone Number
                          </TableCell>
                        }
                        {(activeTable !== 0) &&
                          <TableCell>
                            Email ID
                          </TableCell>
                        }
                        {(activeTable === 1) &&
                          <>
                            <TableCell>
                              Self
                            </TableCell>
                            <TableCell>
                              Beneficiary
                            </TableCell>
                          </>
                        }
                        {(activeTable === 2) &&
                          <>
                            <TableCell>
                              Grade
                            </TableCell>
                            <TableCell>
                              Payment Type
                            </TableCell>
                            </>
                        }
                        { (activeTable === 2 || activeTable === 4) && <>
                          <TableCell>
                          Package
                        </TableCell>
                        <TableCell>
                          Appointment Date
                        </TableCell>
                        <TableCell>
                          Status
                        </TableCell>
                        </>
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {((activeTable !== 1 && (displayEmployees.length > 0))? displayEmployees: displayEmployees.slice(page * limit, (page + 1) * limit)).map((employee, idx) => (
                        <TableRow
                          hover
                          key={idx}
                        // key={employee.requestId}
                        // selected={selectedEmployeeIds.indexOf(employee.requestId) !== -1}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              sx={{
                                '& .MuiSvgIcon-root': {
                                  fontSize: 18
                                }
                              }}
                              value="true"
                            />
                          </TableCell>
                          {(activeTable === 0 || activeTable === 1 || activeTable === 2 || activeTable === 4) &&
                            <>
                              <TableCell>
                                {employee.employeeid ? employee.employeeid : employee.emplId ? employee.emplId : employee.EmployeeID} 
                              </TableCell>
                            </>
                          }
                          {(activeTable === 2 || activeTable === 4) &&
                          <>
                            <TableCell>
                              {employee.AppointmentId}
                            </TableCell>
                          </>
                        }
                          <TableCell>
                            {/* <Box
                              sx={{
                                alignItems: 'center',
                                display: 'flex'
                              }}
                            >
                              <Typography
                                color="textPrimary"
                                variant="body1"
                              > */}
                            {employee.PatientName ? employee.PatientName : employee.name ? employee.name : employee.Name}
                            {/* </Typography>
                            </Box> */}
                          </TableCell>
                          {(activeTable === 2 || activeTable == 4) &&
                            <TableCell>
                              {employee.Relation}
                            </TableCell>
                          }
                          {(activeTable == 0 || activeTable == 1 || activeTable == 4) && 
                            <TableCell>
                              {employee.gender && employee.gender.toUpperCase()}
                            </TableCell>
                          }
                          {(activeTable === 0 || activeTable === 1) &&
                            <TableCell>
                              {moment(employee.dob).format('DD-MM-YYYY')}
                            </TableCell>
                          }
                          {(activeTable === 1 || activeTable == 4) &&
                          <TableCell>
                            {employee.age}
                          </TableCell>
                         }
                          <TableCell>
                            {employee.MobileNumber ? employee.MobileNumber : employee.phNumber}
                          </TableCell>
                          <TableCell>
                            {employee.EmailId || employee.emailId ? employee.EmailId ? employee.EmailId.toLowerCase() : employee.emailId.toLowerCase()  : ''}
                          </TableCell>
                          {(activeTable === 1) &&
                            <>
                              <TableCell>
                                {employee.self}
                              </TableCell>
                              <TableCell>
                                {employee.Benf}
                              </TableCell>
                            </>
                          }
                          {(activeTable === 2) &&
                            <>
                              <TableCell>
                                {`unknown`}
                              </TableCell>
                              <TableCell>
                                {employee.paymentType ? employee.paymentType : 'Sponsored'}
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    width: 150
                                  }}
                                >
                                  {/* <Typography
                                    color="textPrimary"
                                    variant="body1"
                                  > */}
                                  {employee.ProductName}
                                  {/* </Typography> */}
                                </Box>
                                {/* {employee.ProductName ? employee.ProductName : 'Nil'} */}
                              </TableCell>
                              <TableCell>
                                {moment(employee.ApptDate).format('DD-MM-YYYY')}
                              </TableCell>
                              <TableCell>
                                 {employee.Status}
                              </TableCell>
                            </>
                          }
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </PerfectScrollbar>
            <TablePagination
              component="div"
              count={totalCount}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Card>
        </Grid>

      </Grid>
    </>
  )
}

export default AhcResults
